import React, {Fragment, useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles, withStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import {ToggleButtonGroup, ToggleButton} from "@material-ui/lab";
import Button from "@material-ui/core/Button";
import PilProjectData from "./pilSection/pilProjectData";
import ConfirmDialog from "../../Dialog/ConfirmDialog";
import {updatePilDetails, lockPilData} from "../../../dataSource/pil";
import {pasDetailFormStyle} from "../../../styles/jss/components/PAS/pasDetailFormStyle";

const useStyles = makeStyles((theme) => pasDetailFormStyle(theme));
const ProjectInformationEditForm = (props) => {
    const classes = useStyles();
    const [stage, setStage] = useState("1");
    const [error, setError] = useState([]);
    const pilDataRedux = useSelector((state) => state.pilDetailsRedux);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [confirmDialogData, setConfirmDialogData] = useState({
        dialogTitle: "", dialogContent: "", confirmAction: "", cancelAction: "",
    });
    const {
        editable,
        setEditable,
        pilDetails,
        pilStageTwoDetails,
        setPilDetails,
        buildAlert,
        updateFlag,
        setUpdateFlag,
        htmlStr,
        lock,
        lockRight
    } = props;

    const returnToDetails = () => {
        confirmDialogHandleOpen({
            dialogTitle: "Return",
            dialogContent: "Are you sure to return to Project Information Details?",
            confirmAction: () => returnToDetailsConfirmAction(),
            cancelAction: confirmDialogHandleClose,
        });
    };

    const lockToDetails = () => {
        confirmDialogHandleOpen({
            dialogTitle: "Lock",
            dialogContent: "Are you sure about locking project information details?",
            confirmAction: () => lockToDetailsConfirmAction(pilDetails.general.pil_seq),
            cancelAction: confirmDialogHandleClose,
        });
    };

    const returnToDetailsConfirmAction = () => {
        window.location.href = "/pil";
    }

    const lockToDetailsConfirmAction = (pil_seq) => {
        lockPilData(pil_seq).then(r => {
            setEditable(false);
            setUpdateFlag(!updateFlag);
            buildAlert({
                // Alert Type: success, info, warning, error
                type: "success", title: "Success Alert", content: "The Project Information has been locked down"
            });
        })
    }

    const validate = () => {
        let sics = pilDetails.sics;
        for (const sic of sics) {
            let full_name = sic?.full_name;
            if(!full_name || full_name === ""){
               return false
            }
        }

        return error.length <= 0;
    };

    const submitDetails = () => {
        if (validate()) {
            confirmDialogHandleOpen({
                dialogTitle: "Submit Project Details Change",
                dialogContent: "Are you sure to submit changes on Project Information Details?",
                confirmAction: () => submitDetailsConfirmAction(pilDetails.general.pil_seq),
                cancelAction: confirmDialogHandleClose,
            });
        }
    };
    const submitDetailsConfirmAction = (pil_seq) => {
        updatePilDetails(pil_seq, pilDetails).then((res) => {
            setEditable(false);
            setUpdateFlag(!updateFlag);
            buildAlert({
                // Alert Type: success, info, warning, error
                type: "success", title: "Success Alert", content: "The Project Information change has been saved",
            });
        });
    };
    const confirmDialogHandleOpen = (data) => {
        setConfirmDialogData({
            dialogTitle: data.dialogTitle,
            dialogContent: data.dialogContent,
            confirmAction: data.confirmAction,
            cancelAction: data.cancelAction,
        });
        setConfirmDialogOpen(true);
    };

    const confirmDialogHandleClose = () => {
        setConfirmDialogOpen(false);
    };

    return (<Fragment>
        <ConfirmDialog
            open={confirmDialogOpen}
            dialogTitle={confirmDialogData.dialogTitle}
            dialogContent={confirmDialogData.dialogContent}
            confirmAction={confirmDialogData.confirmAction}
            cancelAction={confirmDialogData.cancelAction}
        />
        <div
            style={{
                height: window.outerHeight - (window.outerHeight - window.innerHeight + 250),
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            <div>
                {/*
          <Grid item xs={12}>
            <ToggleButtonGroup
              style={{ border: "1px solid rgb(182 207 237)" }}
              value={stage}
              color="primary"
              size={"small"}
              exclusive
              onChange={handleToggleChange}
            >
              <ToggleButton value="1">Stage One</ToggleButton>
              {pilDataRedux !== null &&
                pilDataRedux.uploadFiles &&
                pilDataRedux.uploadFiles.filter((a) => a.stage === "1").length >
                  0 && <ToggleButton value="2">Stage Two</ToggleButton>}
            </ToggleButtonGroup>
          </Grid>
          */}
                <Grid item xs={12}>
                    {pilDetails.general && pilDetails && (<div className={classes.editSection} tabIndex="0" id="0">
                        <PilProjectData
                            editable={editable}
                            pilDetails={pilDetails}
                            setPilDetails={setPilDetails}
                            htmlStr={htmlStr}
                            error={error}
                            setError={setError}
                            stage={stage}
                        />
                    </div>)}
                    {/*

          {pilStageTwoDetails.general && pilStageTwoDetails && stage === "2" && (
              <div className={classes.editSection} tabIndex="0" id="0">
                <ProjectInformationStageTwoForm
                  setUpdateFlag={setUpdateFlag}
                  editable={editable}
                  pilDetails={pilStageTwoDetails}
                  setPilDetails={setPilDetails}
                  htmlStr={htmlStr}
                  stage={stage}
                />

              </div>
            )}
          */}
                </Grid>
            </div>
        </div>
        <br/>

        <div className={classes.btnClass}>
            <Grid item xs={12}>
                <Button onClick={submitDetails} variant="contained" color="primary">
                    Save
                </Button>
                &nbsp;
                <Button onClick={returnToDetails} variant="contained" color="primary">
                    Cancel
                </Button>
                &nbsp;

                {!lock ? lockRight ? <Button onClick={lockToDetails} variant="contained" color="primary">
                    Lock
                </Button> : <></> : <></>
                }

            </Grid>
        </div>
    </Fragment>);
};

export default ProjectInformationEditForm;
